<template>
    <div class="users-style" >

        

        <table class="table table-sticky">
           <thead>
                <tr class="table-head">
                    <th>Company</th>
                    <th v-for="user in users" :key="user.id">
                        {{user.name}}<br />
                        [{{show_user_level[user.user_level].text}}] <template v-if="user.rootuser == 1">*</template>
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr class="hover-bg table-row" v-for="company in companies" :key="company.value">
                    <td>
                        {{company.text}}
                    </td>
                    <td v-for="user in users" :key="user.id">                    
                        <template v-if="user.user_level < 3">
                            <b-form-checkbox disabled :indeterminate.sync="indeterminate">                       
                            </b-form-checkbox>
                        </template>
                        <template v-else>                        
                            <b-form-checkbox v-model="assigned_users[user.user_id][company.value]" @change="assignUser(user.user_id , company.value)"  >{{company.id}}</b-form-checkbox>
                        </template>
                    </td>
                </tr>
            </tbody>
        </table>

        <br />

        
    </div>

</template>

<script>
    export default{
        
        mounted() {
           
        },
        data(){            
            
            return {
                
                users : [],
                companies : [],
                assigned_users : [],
                                
                blankmsg : 'Fetching data..',
                
                show_user_level: [
                    { value: "0", text: "Select..." },
                    { value: "1", text: "Select..." },
                    { value: "2", text: "Admin" },
                    { value: "3", text: "Manager" },
                    { value: "4", text: "Officer" },
                ],

                checked: true,
                indeterminate: true,
                                
            }
        },
        methods:{
            assignUser :function(user_id , company_id)
            {
                let flg = 0;

                if(this.assigned_users[user_id][company_id]) flg=1;
                //alert(this.assigned_users[user_id][company_id]);
                
                let currentObj = this;
                
                let formData = new FormData();                    
                formData.append('user_id', user_id);
                formData.append('company_id', company_id);
                formData.append('flg', flg);

                axios.post(this.$api_url+'/agent/assigned-users', formData)
                            .then(function (response) 
                            {
                                                    

                                this.$bvToast.toast('Saved!', {
                                        title: `Success`,
                                        variant: 'success',
                                        solid: true
                                    });

                                
                            }.bind(this))
                            .catch(function (error) 
                            {
                                currentObj.serverError(error);
                                currentObj.errormsg = error.response.data.errors;                                    
                            });
            },
            getAgentUsers: function()
            {
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/agent/userlist' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.users = response.data;
                    if(this.users.length == 0)
                        this.blankmsg = "Nothing found.";
                        
                }.bind(this)).catch(function (error){this.serverError(error);});
            },    
            getCompanies: function(){
              axios.get(this.$api_url+'/agent/company/list')
              .then(function (response) {
                    this.companies = response.data;                    
              }.bind(this));
         
            },
            getAssignedUsers: function(){
              axios.get(this.$api_url+'/agent/assigned-users')
              .then(function (response) {
                    this.assigned_users = response.data;
                    //console.log(this.assigned_users);
              }.bind(this));
         
            },

        },
        created: function(){
            this.getAgentUsers();
            this.getCompanies();
            this.getAssignedUsers();
            
        },
    }
</script>